import { Button } from "../ui/button";
import { Gem, Swords, Shirt, FlaskConical, Package } from "lucide-react";

const RARITY_COLORS = {
  common: "#9ca3af",
  uncommon: "#4d7c0f",
  rare: "#3b82f6",
  legendary: "#D4AF37",
};
const TYPE_ICONS = { weapon: Swords, armor: Shirt, consumable: FlaskConical, treasure: Gem, gear: Package };

export default function ItemCard({ card, testId, actions }) {
  const Icon = TYPE_ICONS[card.type] || Package;
  const rarityColor = RARITY_COLORS[card.rarity] || RARITY_COLORS.common;

  return (
    <div
      data-testid={testId || `item-card-${card.id}`}
      className="rounded-xl border-2 p-3 bg-gradient-to-b from-black/50 to-black/20 space-y-1.5"
      style={{ borderColor: rarityColor }}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5">
          <Icon className="w-4 h-4 shrink-0" style={{ color: rarityColor }} />
          <p className="font-display text-lg leading-tight">{card.name}</p>
        </div>
        <span className="text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded-full shrink-0" style={{ color: rarityColor, borderColor: rarityColor, borderWidth: 1 }}>
          {card.rarity}
        </span>
      </div>
      {card.traits?.length > 0 && (
        <div className="flex gap-1 flex-wrap">
          {card.traits.map((t) => (
            <span key={t} className="text-[9px] uppercase px-1.5 py-0.5 rounded-full bg-white/10 text-[#f1e0c5]/60">{t}</span>
          ))}
        </div>
      )}
      {card.bonus_text && <p className="text-xs text-[#D4AF37]">{card.bonus_text}</p>}
      {(card.damage_dice || card.ac_bonus > 0) && (
        <p className="text-xs text-[#f1e0c5]/60">
          {card.damage_dice && `${card.damage_dice} ${card.damage_type || ""} damage`}
          {card.ac_bonus > 0 && `+${card.ac_bonus} AC`}
        </p>
      )}
      {card.description && <p className="text-xs text-[#f1e0c5]/50 font-body">{card.description}</p>}
      {(card.bulk || card.cost) && (
        <p className="text-[10px] text-[#f1e0c5]/30">{card.bulk && `Bulk ${card.bulk}`} {card.cost && `· ${card.cost}`}</p>
      )}
      {card.price_amount > 0 && (
        <p className="text-[10px] text-[#D4AF37]/60">
          Price: {card.price_amount} {card.price_currency || "gp"}
          {card.infinite === false && <span className="text-[#f1e0c5]/40"> · {card.quantity} in stock</span>}
        </p>
      )}
      {actions && <div className="flex gap-1.5 flex-wrap pt-1">{actions}</div>}
    </div>
  );
}
